<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5209 3.70003L15.3209 2.48338C15.2209 2.38338 15.1042 2.33337 14.9709 2.33337C14.8376 2.33337 14.7042 2.38338 14.6209 2.48338L7.63757 9.56671C7.58757 9.61671 7.55423 9.66671 7.52089 9.73338L6.73757 11.7167C6.6709 11.9 6.70423 12.1167 6.85423 12.25C6.95423 12.35 7.07089 12.4 7.20422 12.4C7.27089 12.4 7.32091 12.3834 7.38757 12.3667L9.35423 11.5834C9.42089 11.55 9.47089 11.5167 9.52089 11.4667L16.5042 4.38338C16.7209 4.20005 16.7209 3.88337 16.5209 3.70003ZM8.90424 10.7L8.10423 11.0167L8.4209 10.2L14.9709 3.55005L15.4709 4.05005L8.90424 10.7ZM14.0042 10.1V16.8334C14.0042 17.2 13.6709 17.5 13.3042 17.5H3.83757C3.4709 17.5 3.1709 17.2 3.1709 16.8334V4.13338C3.1709 3.76672 3.4709 3.50004 3.83757 3.50004H10.7709C11.1376 3.50004 11.4376 3.80004 11.4376 4.16671C11.4376 4.53337 11.1376 4.83337 10.7709 4.83337H4.50423V16.1667H12.6709V10.1C12.6709 9.73337 12.9709 9.43337 13.3376 9.43337C13.7042 9.43337 14.0042 9.73337 14.0042 10.1Z" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: 'reloadIcon',
    props: {
      fill: {
        type: String,
        default: '#00527F'
      }
    }
  }
</script>

<style scoped>
  svg:hover path {
    fill: #29ABE2;
  }
</style>

